import { connect } from "react-redux";

import {
	loadLogin,
	submitLogin,
	facebookLogin,
	submitReset,
	changeScreen,
	reactivateAccount,
} from "ducks/login";
import { confirmToken } from "ducks/recaptcha";

import App from "apps/login/components/App";

function mapStateToProps(state) {
	const { login } = state;

	return {
		...login,
	};
}

const mapDispatchToProps = {
	loadLogin,
	submitLogin,
	facebookLogin,
	submitReset,
	changeScreen,
	reactivateAccount,
	confirmRecaptchaToken: confirmToken,
};

export default connect(
	mapStateToProps,
	mapDispatchToProps,
)(App);



// WEBPACK FOOTER //
// ./src/apps/login/index.js